import { render, staticRenderFns } from "./_store.fields.vue?vue&type=template&id=51a8b20e&scoped=true&"
import script from "./_store.fields.vue?vue&type=script&lang=js&"
export * from "./_store.fields.vue?vue&type=script&lang=js&"
import style0 from "./_store.fields.vue?vue&type=style&index=0&id=51a8b20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8b20e",
  null
  
)

export default component.exports